import { render, staticRenderFns } from "./StatisticTableGroup.vue?vue&type=template&id=515cdd7b&scoped=true"
import script from "./StatisticTableGroup.vue?vue&type=script&lang=js"
export * from "./StatisticTableGroup.vue?vue&type=script&lang=js"
import style0 from "./StatisticTableGroup.vue?vue&type=style&index=0&id=515cdd7b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515cdd7b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('515cdd7b')) {
      api.createRecord('515cdd7b', component.options)
    } else {
      api.reload('515cdd7b', component.options)
    }
    module.hot.accept("./StatisticTableGroup.vue?vue&type=template&id=515cdd7b&scoped=true", function () {
      api.rerender('515cdd7b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FinanceVer2/TuitionStatistics/Group/StatisticTableGroup.vue"
export default component.exports